import { isArray, isNumber, isObject, isString } from '../utils/typeUtils';

export type ReleaseComponentApi = {
  id?: number;
  componentName: string;
  repositoryUrl: string;
  manifestName: string;
  targetKeys: string[];
};

export type ReleaseComponent = {
  id?: number;
  componentName: string;
  repositoryUrl: string;
  manifestName: string;
  targetKeys: { value: string }[];
};

/**
 * コンポーネント 型ガード
 */
export const isReleaseComponent = (
  arg: unknown,
): arg is ReleaseComponentApi => {
  const a = arg as ReleaseComponentApi;

  return (
    isObject(a) &&
    isNumber(a.id) &&
    isString(a.componentName) &&
    isString(a.repositoryUrl) &&
    isString(a.manifestName) &&
    isArray(a.targetKeys, isString)
  );
};

export const isReleaseComponents = (
  arg: unknown,
): arg is ReleaseComponentApi[] => isArray(arg, isReleaseComponent);
